import { defineStore } from "pinia";
import { ref } from "vue";
import useMyFetch from "@stores/useMyFetch";

export const useHistoStore = defineStore("histo", () => {
  const histos = ref([]);
  const filtersHisto = ref({});
  const pagination = ref({
    currentPage: 1,
    perPage: 50,
    totalCount: 0,
    totalPages: 0,
  });

  const fetchHistos = async ({
    filters = {},
    target = null,
    topic = null,
    page = 1,
    perPage = 50,
    query = "",
  } = {}) => {
    const params = new URLSearchParams();

    if (target) params.append("target", target);
    if (topic) params.append("topic", topic);
    if (page) params.append("page", page);
    if (perPage) params.append("per_page", perPage);
    if (query) params.append("query", query);

    if (filters && Object.keys(filters).length > 0) {
      Object.entries(filters).forEach(([key, values]) => {
        if (Array.isArray(values)) {
          values.forEach((value) => params.append(`filters[${key}][]`, value));
        } else if (values) {
          params.append(`filters[${key}]`, values);
        }
      });
    }

    const queryString = params.toString();
    const url = queryString ? `/histo?${queryString}` : "/histo";

    const { response, data } = await useMyFetch(url).json();

    if (response.value.ok) {
      histos.value = data.value.data;
      pagination.value = {
        currentPage: data.value.pagination.current_page,
        perPage: data.value.pagination.per_page,
        totalCount: data.value.pagination.total_count,
        totalPages: data.value.pagination.total_pages,
      };
    }
    return response.value.ok;
  };

  const fetchHistoFilters = async () => {
    const { response, data } = await useMyFetch(`/histo/filters`).json();

    if (response.value.ok) filtersHisto.value = data.value;
    return filtersHisto.value;
  };

  const resetHistos = () => {
    histos.value = [];
    pagination.value = { currentPage: 1, perPage: 50, totalCount: 0, totalPages: 0 };
  };

  return {
    histos,
    pagination,
    filtersHisto,

    fetchHistos,
    fetchHistoFilters,
    resetHistos,
  };
});
